
// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import timePicker from '../../components/timePicker/timePicker';
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import { instantiateSelect2 } from "../../utilities/select2able";
import { setSwitchery, enableSwitchery, disableSwitchery, instantiateSwitchery } from '../../utilities/instantiateSwitchery';
require("./editAppointmentScheduling.less");
// Additional Imports...

const dayShiftRowHtml = require('./html/dayShiftRow.html');
const newShiftHtml = require('./html/newShift.html');
const plannedOperationClosureHtml = require('./html/plannedOperationClosure.html');
const targetSelector = "#master-appointment-schedule-edit";

run(targetSelector, (mainEl)=>{
  const editAppointmentScheduling = mainEl.data('master-edit-data');
  const saveAppSchedulingURL = mainEl.data('save-appscheduling-url');
  const mainHtml = render(
    require("./html/editAppointmentScheduling.html"), {
    shiftRows: renderShiftRows(editAppointmentScheduling[0].masterAppointmentConfig.scheduleDetails),
    plannedOperationClosure:   render(require('./html/plannedOperationClosure.html'),
    {
      closureDates: getClosureDates(editAppointmentScheduling[0].masterAppointmentConfig.plannedOperationClosures.closureDates),
      //isClosureFullDay : getTargetSelector(closureDate.isClosureFullDay),
    }),
  }
  );
  const el = $(mainHtml);
  mainEl.append(el);
  initiateDatePickers();
 
  // END: REQUIRED TO LOAD STUB

  // START: REAL CODE

  let els = {};
  let elsPage ={};

  let $body = $('body');

  let submitModalFlow;

  let toggleForClosure=1;

  let numberOfPlannedClosureDates=0;

  let monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  

  let elementsMap = {
    addTimeBlockBtn: '.addTime-block-btn',
    dayShiftRow: '.day-shift-row',
    submitScheduleBtn: '.submit-schedule-btn',
    cancelScheduleBtn: '.cancel-schedule-btn',  
    dayOfWeekCheckbox: '.day-of-week-checkbox',
    
  }

  let elsPageMap={
    closureFullDay : '#closure-full-day',
    editMasterToggle : '.edit-master-toggle'
  }

  let shiftTimes = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  }

  let savedShiftTimes = {
    //Sample data for saved shift times
    /* monday: [
       {
         from: '10:05',
         to: '12:05'
       },
       {
         from: '12:06',
         to: '14:05'
       },
       {
         from: '14:06',
         to: '16:05'
       }
      ],*/
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  }

  function init() {
    setElement();
    bindElement();
    initiateTimePickers();
    testSwitchery();
    fillClosureEditTimes();  
  }

  function testSwitchery(){
    let  map = editAppointmentScheduling[0].masterAppointmentConfig.plannedOperationClosures.closureDates;
    let k =0;
    for(let i=1;i<=map.length;i++){
       if(map[k].isClosureFullDay){
          instantiateSwitchery($('#closure-full-day-'+i), {});
          setSwitchery($('#closure-full-day-'+i) , true);
       }
       k++;
    }

  }

  function fillClosureEditTimes(){
    let closureEditTimes = editAppointmentScheduling[0].masterAppointmentConfig.plannedOperationClosures.closureDates;
    for (let i=0;i<=closureEditTimes.length;i++){
      if(!(typeof closureEditTimes[i].closureTime[0] === 'undefined')){
        if(closureEditTimes[i].closureTime[0].closureShiftStartTime !=null){
          const closureTimes = $('#closure-edit-time-'+i);
          const timePickerArea =  closureTimes.find('.time-picker-area');
          const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
          timeFrom.enableTimePicker();
          timeFrom.setTimeFromMilitary(closureEditTimes[i].closureTime[0].closureShiftStartTime);
          const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
          timeTo.enableTimePicker();
          timeTo.setTimeFromMilitary(closureEditTimes[i].closureTime[0].closureShiftEndTime);
        }
    }
  }
}


  function setElement() {
    setElementsFromScope(els, elementsMap, $body);
    setElementsFromScope(elsPage,elsPageMap,$body);
  }

  function bindElement() {

    mainEl.on('click', '.addTime-block-btn', onAddShiftBtnClick);
    mainEl.on('click', '.new-shift-add-shift-btn', onAddNewShiftBtnClick);
    mainEl.on('click', '.remove-shift-btn', onRemoveShiftBtnClick);
    els.submitScheduleBtn.on('click', onSubmitBtnClick);
    els.cancelScheduleBtn.on('click', onCancelBtnClick);
    els.dayOfWeekCheckbox.on('change', handleCheckboxChange);
    mainEl.on('click', '.remove-date-btn', onRemoveDateBtnClick);
    mainEl.on('click', '.add-date-btn', addDateBtnClick);

    var arr=editAppointmentScheduling[0].masterAppointmentConfig.scheduleDetails.dosDays;
        var shifts = _.groupBy(_.sortBy(arr, "dosStartTime"), 'dosDay');
		
		
		for (const day in shifts) {
      
      var e = shifts[day];
      var i;
      for (i = 0; i < e[0].dosTime.length; i++) {
        savedShiftTimes[day.toLowerCase()].push({from:e[0].dosTime[i].dosStartTime,to:e[0].dosTime[i].dosEndTime});
      }
    }
  }

  // function generateModals() {
  //   submitSchedulModal = new SubmitModalFlow({
  //     confirmModalTitle: 'Submit Schedule Information',
  //     confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to accurately display available appointment slots for dock scheduling.</div>',
  //     confirmModalBtnText: 'Submit',
  //     modalDialogClass: "q-modal-dialog-500",
  //     onConfirmClick: function () {
  //       // Show Loading Modal
  //       submitSchedulModal.showLoadingModal();

  //       // Success
  //       setTimeout(function () {
  //         submitSchedulModal.showSuccessModal();
  //       }, 3000);

  //       // Hide All Modals
  //       setTimeout(function () {
  //         submitSchedulModal.hideAllModals();
  //       }, 6000);
  //     }
  //   });
  //   submitSchedulModal.init();
  // }


  function onRemoveDateBtnClick(e) {
    e.preventDefault();
    const removeDateHtml = $(this).closest('.remove-date-details');
    removeDateHtml.remove();
  }

  function onAddShiftBtnClick(e) {
    e.preventDefault();
    const timePickerArea = $(this).closest('.time-picker-area');
    const dayOfWeek = timePickerArea.data('day-of-week');
    const timeFromVal = timePicker(timePickerArea.find('.time-picker-from'));
        const timeToVal = timePicker(timePickerArea.find('.time-picker-to'));
        let dayShiftRow = $(this).closest('.day-shift-row');
        let timeValidAlert = dayShiftRow.find('.q-alert');
        var timeCheckObj = vaidateDefaultTimeRange(timeFromVal.getMilitaryTime(),timeToVal.getMilitaryTime());
        if(timeCheckObj.isValid){
            timePickerArea.find('.addTime-block-btn').removeClass('disabled');
            timePickerArea.find('.default-add-shift-btn').hide();
            timeValidAlert.hide();
            addNewShifRow(timePickerArea,dayOfWeek);
        }else{
            timeValidAlert.show();
            timeValidAlert.html(timeCheckObj.message);
        }
  }

  function onAddNewShiftBtnClick(e) {
    e.preventDefault();
    var btn = $(this);
    const timePickerArea = btn.closest('.time-picker-area');
    const dayOfWeek = timePickerArea.data('day-of-week');
    const shiftToValidate = btn.closest('.new-shift');
    let dayShiftRow = $(this).closest('.day-shift-row');
    let timeValidAlert = dayShiftRow.find('.q-alert');
    let timeFromPreviousVal ;
    let timeToPreviousVal ;
    // if(shiftTimes[dayOfWeek].length > 1){
    //     timeFromPreviousVal = shiftTimes[dayOfWeek][1].timeFrom;
    //     timeToPreviousVal = shiftTimes[dayOfWeek][1].timeTo;
    // }
        timeFromPreviousVal = timePicker(timePickerArea.find('.time-picker-from'));
        timeToPreviousVal = timePicker(timePickerArea.find('.time-picker-to'));
    
    
    const timeFrom = timePicker(shiftToValidate.find('.time-picker-from'));
    const timeTo = timePicker(shiftToValidate.find('.time-picker-to'));
    var timeCheckObj = vaidateTimeRange(timeFrom.getMilitaryTime(),timeTo.getMilitaryTime(),timeToPreviousVal.getMilitaryTime());
    if(timeCheckObj.isValid){
        //btn.closest('.new-shift').find('.remove-shift-btn').hide();
        timeValidAlert.hide();
        btn.hide();
        addNewShifRow(timePickerArea,dayOfWeek);
       
    }else{
        if(timeCheckObj.message){
        timeValidAlert.show();
        timeValidAlert.html(timeCheckObj.message);
        }
    }
  }

  function addNewShifRow(timePickerArea,dayOfWeek){
    const $newShiftHtml = $(newShiftHtml);
    const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
    const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
    shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
    
    timePickerArea.append($newShiftHtml);
    if(shiftTimes[dayOfWeek].length>2){
        $newShiftHtml.find('.new-shift-add-shift-btn').hide();
    }
  }

  function vaidateDefaultTimeRange(timeFromValue,timeToValue, previousShiftEndTimeValue){
    var validTimeMsg={};
    if(timeFromValue=="Invalid date"||timeToValue=="Invalid date"){
        validTimeMsg.isValid = false;
        validTimeMsg.message = "Each selected day requires at least one time block.";
    }else if(timeFromValue>timeToValue){
        validTimeMsg.isValid = false;
        validTimeMsg.message = "End time cannot be before start time.";
    }else{
        validTimeMsg.isValid = true;
    }
    return validTimeMsg;
  }

  function vaidateTimeRange(timeFromValue,timeToValue, previousShiftEndTimeValue){
    var validTimeMsg={};
    if(timeFromValue=="Invalid date"||timeToValue=="Invalid date"){
        validTimeMsg.isValid = false;
        //validTimeMsg.message = "Each selected day requires at least one time block.";
    }else if(timeFromValue>timeToValue){
        validTimeMsg.isValid = false;
        validTimeMsg.message = "End time cannot be before start time.";
    }else if( !(typeof previousShiftEndTimeValue === "undefined")){
        if(previousShiftEndTimeValue>timeFromValue){
            validTimeMsg.isValid = false;
            validTimeMsg.message = "Current shift time must be greater than previous shift End time.";
        }else{
            validTimeMsg.isValid = true;
        }
    }else{
        validTimeMsg.isValid = true;
    }
    return validTimeMsg;
  }

  function onRemoveShiftBtnClick(e) {
    e.preventDefault();
    const timePickerArea = $(this).closest('.time-picker-area');
    const dayOfWeek = timePickerArea.data('day-of-week');
    const shiftToRemove = $(this).closest('.new-shift');
    const indexToRemove = shiftToRemove.index();
    $(shiftToRemove).remove();
    shiftTimes[dayOfWeek].splice(indexToRemove, 1);
    if (shiftTimes[dayOfWeek].length < 3) {
      timePickerArea.find('.addTime-block-btn').removeClass('disabled');
    }
    if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 3) {
      timePickerArea.find('.addTime-block-btn').show();
      timePickerArea.find('.default-addTime-block-btn').hide();
    }
    if (shiftTimes[dayOfWeek].length == 1) {
      timePickerArea.find('.default-addTime-block-btn').show();
    }
  }

  function validateForm(formElement) {
    let validator, validationOpts; 
    validationOpts = {
      ignore: '*:not([name])', 
      rules: {
        // simple rule, converted to {required:true}
      },
      debug: true,
      errorPlacement: function (error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    };
    validator = formElement.validate(validationOpts);
    validator.settings.ignore = ":disabled,:hidden";

    if (formElement.valid()) {
      return true;
    } else {
      return false;
    }
  }

  function validateCheckbox(){
    let isDisplayed= true;
    els.dayShiftRow.each((index, el) => {
      const $el = $(el);
      const dayOfWeek = $el.data('day-of-week');
      const timePickerArea = $el.find('.time-picker-area');
      const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
      const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
      const dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
      let isChecked =dayOfWeekCheckbox.is(':checked');
      let dayShiftRow = $(el).closest('.day-shift-row');
      let timeValidAlert = dayShiftRow.find('.q-alert');
      var timeCheckObj = vaidateDefaultTimeRange(timeFrom.getMilitaryTime(),timeTo.getMilitaryTime());
      if(isChecked && !timeCheckObj.isValid){
        timeValidAlert.show();
        timeValidAlert.html(timeCheckObj.message);
        isDisplayed = false;
      }
    });
    return isDisplayed;
  }

  function getShiftTimes(){

    const shiftTimesToSave = {};

    Object.keys(shiftTimes).forEach((key) => {
      shiftTimesToSave[key] = shiftTimes[key].map((el) => {
        return {
          from: el.timeFrom.getMilitaryTime(),
          to: el.timeTo.getMilitaryTime()
        }
      });
    });

    var dosDays=[],p=0;
      Object.keys(shiftTimesToSave).forEach((key) => {
        dosDays[p]={};
        dosDays[p].dosDay = key;
        dosDays[p].dosTime =[];
        dosDays[p].dosTime = shiftTimesToSave[key].map((el) => {
          if(el.from != "Invalid date"){
            return {dosStartTime: el.from,dosEndTime: el.to}
          }
          });
        p++;
      });

      const capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
      }
      var dockShifts=[];
      for (let index = 0; index < dosDays.length; index++) {
        const element = dosDays[index];
        
          const array = element.dosTime;
          if(!(typeof(array[0]) == 'undefined' || array[0] === null))
          {
            for (let j = 0; j < array.length; j++) {
              const dtime = array[j];
              dockShifts.push({dosDay:capitalize(element.dosDay),dosStartTime:dtime.dosStartTime,dosEndTime:dtime.dosEndTime});
            }
          }   
      }
      return dockShifts;
  }

  function getPlannedOperationClosures(){

    let plannedOperationClosuresToSave = {};
    

    

  }

  function onSubmitBtnClick(e) {
    e.preventDefault();
    let shiftTimes = getShiftTimes();
    let plannedOperationClosures = getPlannedOperationClosures();
      let appSchedulingToSave = {
        appShifts:shiftTimes 
      };
      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: "Submit Schedule Information",
        confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to accurately display available appointment slots for dock scheduling.</div>',
        confirmModalBtnText: "Submit",
        modalDialogClass: "q-modal-dialog-500",
        onConfirmClick: function () {
          submitModalFlow.showLoadingModal();
          $.ajax({
            data:  {
              appointmentSchedule : JSON.stringify($("#edit-appointment-scheduling-form").serialize())
            },
              //   {
            
          //   appointmentSchedule: JSON.stringify(appSchedulingToSave)
          // },
            url: saveAppSchedulingURL,
            dataType: "JSON",
            type: 'POST',
            success: function (data) {
              EditChecker.setPageClean();
              submitModalFlow.hideAllModals();
              submitModalFlow.showSuccessModal();
              setTimeout(function () {
                 
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            },
            error: function (data) {
              submitModalFlow.hideAllModals();
              submitModalFlow.showFailureModal();
            }
          });
          
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
  }

  function onCancelBtnClick(e){
    e.preventDefault();
    $('#master-appointment-schedule-edit').hide();
    $('#master-appointment-schedule').show();

  }
  function getTimeInMilitaryTime(time){
    const x=time.split(":");
    x[1]=x[1].replace(/\s\s+/g, ' ');
    const y = x[1].split(" ");
    
    return  moment(x[0]+ ":" + y[0] + " " + y[1], 'h:mm A').format('HH:mm');
    
  }
  function initiateTimePickers() {
    els.dayShiftRow.each((index, el) => {
      const $el = $(el);
      const dayOfWeek = $el.data('day-of-week');
      const timePickerArea = $el.find('.time-picker-area');
      const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
      const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
      const dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
      timeFrom.disableTimePicker();
      timeTo.disableTimePicker();
      shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
      if (savedShiftTimes[dayOfWeek].length == 1) {
        dayOfWeekCheckbox.prop('checked', 'true');
        timePickerArea.find('.default-addTime-block-btn').removeClass('disabled');
        timeFrom.enableTimePicker();
        timeTo.enableTimePicker();
        timeFrom.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].from));
        timeTo.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].to));

      } else if (savedShiftTimes[dayOfWeek].length > 1 && savedShiftTimes[dayOfWeek].length <= 3) {
        dayOfWeekCheckbox.prop('checked', 'true');
        timePickerArea.find('.default-addTime-block-btn').hide();
        timePickerArea.find('.new-shift-add-shift-btn').removeClass('disabled');
        timeFrom.enableTimePicker();
        timeTo.enableTimePicker();
        timeFrom.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].from));
        timeTo.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].to));
        //timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
        //timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
        savedShiftTimes[dayOfWeek].shift();
        savedShiftTimes[dayOfWeek].map((shift) => {
          const $newShiftHtml = $(newShiftHtml);
          const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
          const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
          timePickerArea.append($newShiftHtml);
         
        timePickerArea.find('.new-shift-add-shift-btn').removeClass('disabled');
        timeFrom.setTimeFromMilitary(getTimeInMilitaryTime(shift.from));
        timeTo.setTimeFromMilitary(getTimeInMilitaryTime(shift.to));
          //timeFrom.setTimeFromMilitary(shift.from);
          //timeTo.setTimeFromMilitary(shift.to);
          shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
        });
      }
      if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 3) {
        timePickerArea.find('.new-shift-add-shift-btn').addClass('disabled');
      }
    });
  }

  function renderShiftRows(scheduleDetails) {
    let days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    //let days = ['Monday', 'Tuesday'];
    const shiftRow = days.map((day) => {
      return render(dayShiftRowHtml, {
        day
      });
    });

    return shiftRow.join('');
  }

  function handleCheckboxChange() {
    let isChecked = $(this).is(':checked');
    let dayShiftRow = $(this).closest('.day-shift-row');
    let dayOfWeek = dayShiftRow.data('day-of-week');
    if (isChecked) {
      shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
      shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
      dayShiftRow.find('.addTime-block-btn').removeClass('disabled');
      dayShiftRow.find('.default-addTime-block-btn').show();
    } else {
      dayShiftRow.find('.new-shift').remove();
      shiftTimes[dayOfWeek].length = 1;
      shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
      shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
      shiftTimes[dayOfWeek][0].timeFrom.resetTime();
      shiftTimes[dayOfWeek][0].timeTo.resetTime();
      dayShiftRow.find('.addTime-block-btn').addClass('disabled');
      dayShiftRow.find('.default-addTime-block-btn').show();
    }
  }

  function initiateDatePickers() {
    const plannedClosures = $("#planned-closure-details");
    let plannedClosureDate= plannedClosures.find("input[name='add-date-text']");
        const today = new Date();
       plannedClosureDate.datepicker({
          startDate: today,
          todayBtn: "linked",
          keyboardNavigation: false,
          autoclose: true
        });
       
    }

  function addDateBtnClick(e) {
    e.preventDefault();
      const closureDateHtml = require('./html/addClosureDate.html'); 
      const plannedClosures = $("#planned-closure-details");
      let plannedClosureDate= plannedClosures.find("input[name='add-date-text']").val();
      var date=new Date(plannedClosureDate);
      let dateTextToShow = `${monthArr[date.getMonth()]} ${date.getDate()}${nthDay(date.getDate())}, ${date.getFullYear()} :`;
      const closurename="closure-date-"+toggleForClosure;
      const closureDt = render(
        closureDateHtml, {
          plannedClosureDate:dateTextToShow,
          closureDate:closurename,
          toggleForClosure:toggleForClosure
        }
      );
      toggleForClosure++;
      $('#master-appointment-schedule-edit').find("div[name='closure-details']").find(".q-alert").hide();
      numberOfPlannedClosureDates++;
      $('#master-appointment-schedule-edit').find("div[name='closure-details']").append(closureDt);
      instantiateSwitchery($('.js-switchery'));
    
      //const timePickerArea=$(closureDt).find('.time-picker-area');
      const timePickerArea=$('#master-appointment-schedule-edit').find("."+closurename).find('.time-picker-area');
        const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
        const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
        timeFrom.enableTimePicker();
        timeTo.enableTimePicker();
    
      
      
    }

    function getDosDays(dosDays) {
      const dosDaysHtml = require("./html/dockShiftDays.html");
       const response = _.map(dosDays, (dosDay) => {
        return render(dosDaysHtml, {
          dosDay: dosDay,
          dosTimes:getDosTimes(dosDay.dosTime),
        });
      });
      return response.join(""); 
    }
    function getDosTimes(dosTimes) {
      const dosTimesHtml = require("./html/dockShiftTime.html");
       const response = _.map(dosTimes, (dosTime) => {
        return render(dosTimesHtml, {
          dosTime: dosTime,
        });
      });
      return response.join(""); 
    } 

    function getClosureDates(closureDates) {
      const closureDatesHtml = require("./html/closureDates.html");
      let arrayIndex = 0;
       const response = _.map(closureDates, (closureDate,closureTime) => {
        arrayIndex = arrayIndex+1;
        return render(closureDatesHtml, {
          plannedClosureDate : closureDate.closureDate,
          isClosureFullDay:getTargetSelector(closureDate.isClosureFullDay),
          closureTimes : getClosureTimes(closureDate.closureTime,arrayIndex-1),
          // closureShiftStartTime: closureDate.closureTime[0].closureShiftStartTime,
          // closureShiftEndTime : closureDate.closureTime[0].closureShiftEndTime,
          closureDate:"closure-date-"+toggleForClosure,
          toggleForClosure:toggleForClosure,
          arrayIndex
        });
        toggleForClosure++;
      });
      return response.join(""); 
    }

    function getTargetSelector(isClosureFullDay){
      if(isClosureFullDay){
        mainEl.find('#closure-full-day').prop('checked',true);
        return ".large-text-toggle-target";
      }else{
      return "";
      }
    }

    function getClosureTimes(closureTime,closureIndex) {
      const closureTimeHtml = require("./html/closureTimes.html");
       const response = _.map(closureTime, (closureTime) => {
        return render(closureTimeHtml, {
          closureTime: closureTime,
          closureIndex
        });
      });
      return response.join(""); 
    } 

    function nthDay(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    }


  let timePickerFromEl = mainEl.find('.time-picker-from');
  let timePickerToEl = mainEl.find('.time-picker-to');
  
  let timePickerFrom = timePicker(timePickerFromEl);
  let timePickerTo = timePicker(timePickerToEl);

  
  function fillEditTimes(dosDays){
    const dayshiftrows =  $('#edit-dock-area').find('.day-shift-row');
    for(var i=0;i<6;i++){
      if(!(typeof dosDays[i].dosTime[0] === 'undefined')){
      if(dosDays[i].dosTime[0].dosStartTime !=null){
        const dayshiftrow=$(dayshiftrows[i]);
        dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
        dayshiftrow.trigger( "change" );
        const timePickerArea =  dayshiftrow.find('.time-picker-area');
        const dayOfWeek = timePickerArea.data('day-of-week');
        const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
        timeFrom.enableTimePicker();
        timeFrom.setTimeFromMilitary(dosDays[i].dosTime[0].dosStartTime);
        const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
        timeTo.enableTimePicker();
        timeTo.setTimeFromMilitary(dosDays[i].dosTime[0].dosEndTime);
        dayshiftrow.find('.add-shift-btn').removeClass('disabled');
        dayshiftrow.find('.default-add-shift-btn').show();
        dayshiftrow.find('.q-alert').hide();
      }
      if(dosDays[i].dosTime.length>1){
        for(var j=1; j<dosDays[i].dosTime.length;j++){
          if(dosDays[i].dosTime[j].dosStartTime !=null && dosDays[i].dosTime[j].dosStartTime != undefined){
            const dayshiftrow=$(dayshiftrows[i]);
            dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
            dayshiftrow.trigger( "change" );
            const timePickerAreaShift =  dayshiftrow.find('.time-picker-area');
            const dayOfWeek = timePickerAreaShift.data('day-of-week');
            const $newShiftHtml = $(newShiftHtml);
            const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
            timeFrom.enableTimePicker();
            timeFrom.setTimeFromMilitary(dosDays[i].dosTime[j].dosStartTime);
            const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
            timeTo.enableTimePicker();
            timeTo.setTimeFromMilitary(dosDays[i].dosTime[j].dosEndTime);
            timePickerAreaShift.append($newShiftHtml);
            shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
            if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {		
              timePickerAreaShift.find('.add-shift-btn').removeClass('disabled');
              timePickerAreaShift.find('.default-add-shift-btn').hide();
              let dayShiftRow = $(this).closest('.day-shift-row');
              dayShiftRow.find('.q-alert').hide();
            }
              if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 25) {
                timePickerAreaShift.find('.add-shift-btn').hide();
              }
          }
        }
      }
    }
    }
   }

  init();

  // END: REAL CODE
  
});





// WEBPACK FOOTER //
// ./src/pages/editAppointmentScheduling/editAppointmentScheduling.js